import React from 'react';
import { COLORS } from '../constants/theme';

/**
 * Simulation Control Panel Component
 * Provides play/pause, speed control, and mode selection
 */
const SimulationControls = ({
  isRunning,
  isPaused,
  currentHour,
  speed,
  mode,
  onStart,
  onPause,
  onResume,
  onReset,
  onSpeedChange,
  onModeChange,
  config,
  onConfigChange,
}) => {
  const progress = (currentHour / 8783) * 100;
  
  const handleStart = () => {
    // Ensure we run in instant mode (JSON-driven)
    if (onModeChange) onModeChange('instant');
    if (onStart) onStart();
  };

  return (
    <div style={{
      background: COLORS.ui.surface,
      borderRadius: '0.75rem',
      padding: '1.5rem',
      marginBottom: '1.5rem',
      border: `1px solid ${COLORS.ui.border}`,
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '1.5rem',
        flexWrap: 'wrap',
      }}>
        
        {/* Play/Pause Controls */}
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          {!isRunning ? (
            <button
              onClick={handleStart}
              style={{
                padding: '0.5rem 1rem',
                borderRadius: '0.5rem',
                border: 'none',
                background: COLORS.status.success,
                color: 'white',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '1rem',
                transition: 'all 0.2s',
              }}
            >
              ▶ Start
            </button>
          ) : isPaused ? (
            <button
              onClick={onResume}
              style={{
                padding: '0.5rem 1rem',
                borderRadius: '0.5rem',
                border: 'none',
                background: COLORS.status.warning,
                color: 'white',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '1rem',
                transition: 'all 0.2s',
              }}
            >
              ▶ Resume
            </button>
          ) : (
            <button
              onClick={onPause}
              style={{
                padding: '0.5rem 1rem',
                borderRadius: '0.5rem',
                border: 'none',
                background: COLORS.status.warning,
                color: 'white',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '1rem',
                transition: 'all 0.2s',
              }}
            >
              ⏸ Pause
            </button>
          )}
          
          <button
            onClick={onReset}
            style={{
              padding: '0.5rem 1rem',
              borderRadius: '0.5rem',
              border: 'none',
              background: COLORS.status.error,
              color: 'white',
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: '0.875rem',
              transition: 'all 0.2s',
            }}
          >
            ↺ Reset
          </button>
        </div>
        
        {/* Speed Control */}
        {mode === 'step' && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <label style={{ 
              color: COLORS.ui.text.secondary,
              fontSize: '0.875rem',
              fontWeight: '500',
            }}>
              Speed:
            </label>
            <input
              type="range"
              min="1"
              max="100"
              value={speed}
              onChange={(e) => onSpeedChange(Number(e.target.value))}
              style={{
                width: '150px',
                height: '4px',
                background: COLORS.ui.border,
                borderRadius: '2px',
                outline: 'none',
              }}
            />
            <span style={{
              color: COLORS.ui.text.primary,
              fontSize: '0.875rem',
              minWidth: '3rem',
              fontWeight: 'bold',
            }}>
              {speed}x
            </span>
          </div>
        )}
        
        {/* Progress Display */}
        <div style={{ textAlign: 'center', minWidth: '200px' }}>
          {isRunning && !isPaused && (
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.25rem 0.75rem',
              borderRadius: '1rem',
              background: COLORS.status.success + '20',
              color: COLORS.status.success,
              fontSize: '0.75rem',
              fontWeight: 'bold',
              marginBottom: '0.5rem',
            }}>
              <span style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                background: COLORS.status.success,
                animation: 'pulse 1.5s ease-in-out infinite',
              }} />
              KØR
ER...
            </div>
          )}
          <div style={{
            fontSize: '1.5rem',
            fontWeight: 'bold',
            color: COLORS.status.info,
            marginBottom: '0.25rem',
          }}>
            Hour {currentHour} / 8783
          </div>
          <div style={{
            fontSize: '0.875rem',
            color: COLORS.ui.text.secondary,
          }}>
            {progress.toFixed(1)}% Complete
          </div>
          
          {/* Progress Bar */}
          <div style={{
            width: '100%',
            height: '6px',
            background: COLORS.ui.border,
            borderRadius: '3px',
            marginTop: '0.5rem',
            overflow: 'hidden',
          }}>
            <div style={{
              width: `${progress}%`,
              height: '100%',
              background: `linear-gradient(90deg, ${COLORS.status.info}, ${COLORS.status.success})`,
              transition: 'width 0.3s ease',
            }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimulationControls;